module.exports = __webpack_public_path__ + "img/crop4.26369e9a.png";